/**
 * voice-enrollment Web のエントリーポイント。
 *
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business voice-enrollment Web のブラウザ起動エントリーポイント。Faro 初期化後に React ルートをマウント
 * @graph-connects App [calls] React ルートコンポーネント
 */

import { initializeFaro } from '@cortex/faro';
initializeFaro({ appName: 'voice-enrollment' });

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';

/** @graph-connects none */
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

/** @graph-connects none */
const apiBaseUrl = import.meta.env.VITE_API_URL;
if (!apiBaseUrl) {
  throw new Error('VITE_API_URL is required at build time');
}

createRoot(container).render(
  <StrictMode>
    <App apiBaseUrl={apiBaseUrl} />
  </StrictMode>,
);
